/* Yerb homepage reveal: jeden IO, guard, editor-safe.
   Skryvani obsahu je v CSS (base.css) gatovane tridou html.yh-anim, kterou pridava
   az tento skript - kdyz se nenacte (blokace, no-JS), obsah je videt.
   Reduced motion: trida yh-anim se vubec neprida, zadne skryvani ani pohyb,
   plati i pro sekcni overridy (yh-fin__side apod.) gatovane na html.yh-anim.
   Stagger: prvky odhalene ve stejnem IO ticku se seradi podle pozice na obrazovce
   a dostanou 70 ms rozestup pres inline transition-delay.
   Po dobehnuti se yh-reveal a smerove tridy z prvku mazou - jinak by yh-in
   (transform:none, vyssi specificita) blokoval hover transformy karet.
   yh-in zustava: yh-isnt na nem stavi nakresleny skrt.
   Count-up: potomci s [data-yh-count] napocitaji cislo pri odhaleni rodice. */
(function () {
  if (window.__yhReveal) return;
  window.__yhReveal = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('yh-anim');

  var STEP = 70, MAX_DELAY = 280, DUR = 550, COUNT_DUR = 800;

  function countUp(el) {
    var target = parseInt(el.getAttribute('data-yh-count'), 10);
    if (!isFinite(target)) return;
    var t0 = 0;
    function frame(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / COUNT_DUR, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = String(Math.round(target * eased));
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function reveal(el, delay) {
    if (delay > 0) el.style.transitionDelay = delay + 'ms';
    el.classList.add('yh-in');
    var counts = el.querySelectorAll('[data-yh-count]');
    if (counts.length) {
      setTimeout(function () { counts.forEach(countUp); }, delay);
    }
    setTimeout(function () {
      el.style.transitionDelay = '';
      el.classList.remove('yh-reveal', 'yh-reveal--l', 'yh-reveal--r', 'yh-reveal--pop');
    }, delay + DUR + 120);
  }

  var io = new IntersectionObserver(function (entries) {
    var batch = [];
    entries.forEach(function (x) {
      if (x.isIntersecting) { batch.push(x.target); io.unobserve(x.target); }
    });
    if (!batch.length) return;
    batch.sort(function (a, b) {
      var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
      return (ra.top - rb.top) || (ra.left - rb.left);
    });
    batch.forEach(function (el, i) { reveal(el, Math.min(i * STEP, MAX_DELAY)); });
  }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

  function init(scope) {
    (scope || document).querySelectorAll('.yh-reveal:not(.yh-in)').forEach(function (e) { io.observe(e); });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.yh-reveal').forEach(function (el) { io.unobserve(el); });
  });
})();
